import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
    BOOK_REQUEST: {
    path: `${baseRoutes.adminBaseRoutes}/book-request`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-notify" />
      </span>
    ),
  },
};

export default accessRoute;
